import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    fontFamily: 'SF Pro Text',
    colorTextBase: '#000',
    colorTextLightSolid: '#ffffff',
    colorBgBase: '#ffffff',
    colorPrimaryBg: '#686887',
    colorPrimaryBgHover: '#5d5d79',
    colorPrimaryBorder: '#52526b',
    colorPrimaryBorderHover: '#47475c',
    colorPrimaryHover: '#17172F',
    colorPrimary: '#3D3D50',
    colorPrimaryActive: '#0f0f1f',
    colorPrimaryTextHover: '#0c0c18',
    colorPrimaryText: '#080811',
    colorPrimaryTextActive: '#05050a',
    colorSuccessBg: '#f6ffed',
    colorSuccessBgHover: '#d9f7be',
    colorSuccessBorder: '#b7eb8f',
    colorSuccessBorderHover: '#95de64',
    colorSuccessHover: '#73d13d',
    colorSuccess: '#52c41a',
    colorSuccessActive: '#389e0d',
    colorSuccessTextHover: '#237804',
    colorSuccessText: '#135200',
    colorSuccessTextActive: '#092b00',
    colorWarningBg: '#fffbe6',
    colorWarningBgHover: '#fff1b8',
    colorWarningBorder: '#ffe58f',
    colorWarningBorderHover: '#ffd666',
    colorWarningHover: '#ffc53d',
    colorWarning: '#faad14',
    colorWarningActive: '#d48806',
    colorWarningTextHover: '#ad6800',
    colorWarningText: '#874d00',
    colorWarningTextActive: '#613400',
    colorErrorBg: '#fff1f0',
    colorErrorBgHover: '#ffccc7',
    colorErrorBorder: '#ffa39e',
    colorErrorBorderHover: '#ff7875',
    colorErrorHover: '#ff7875',
    colorError: '#ff7875',
    colorErrorActive: '#cf1322',
    colorErrorTextHover: '#a8071a',
    colorErrorTextActive: '#5c0011',
    colorInfoBg: '#686887',
    colorInfoBgHover: '#5d5d79',
    colorInfoBorder: '#52526b',
    colorInfoBorderHover: '#47475c',
    colorInfoHover: '#17172F',
    colorInfo: '#3D3D50',
    colorInfoActive: '#0f0f1f',
    colorInfoTextHover: '#0c0c18',
    colorInfoText: '#080811',
    colorInfoTextActive: '#05050a',
    colorText: '#000000e0',
    colorTextHeading: '#000000e0',
    colorTextDescription: '#00000073',
    colorTextPlaceholder: '#00000040',
    colorTextDisabled: '#00000040',
    colorIcon: '#00000073',
    colorIconHover: '#000000e0',
    colorBgContainer: '#ffffff',
    colorBgContainerDisabled: '#0000000a',
    colorBgLayout: '#f5f5f5',
    colorBgElevated: '#ffffff',
    controlItemBgHover: '#0000000a',
    controlItemBgActive: '#686887',
    controlItemBgActiveHover: '#5d5d79',
    colorBorder: '#00000026',
    colorBorderSecondary: '#0000000f',
    colorSplit: '#0000000f',
  },
  components: {
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      controlHeight: 40,
      controlHeightLG: 40,
    },
    Input: {
      activeShadow: 'none',
      errorActiveShadow: 'none',
      warningActiveShadow: 'none',
      fontSize: 14,
      fontSizeLG: 16,
      paddingInline: 12,
      paddingInlineLG: 12,
      controlHeight: 40,
      controlHeightLG: 40,
    },
    InputNumber: {
      activeShadow: 'none',
      errorActiveShadow: 'none',
      warningActiveShadow: 'none',
      fontSize: 14,
      fontSizeLG: 16,
      paddingInline: 12,
      paddingInlineLG: 12,
      controlHeight: 40,
      controlHeightLG: 40,
    },
    DatePicker: {
      fontSize: 14,
      fontSizeLG: 16,
      paddingInline: 12,
      paddingInlineLG: 12,
      controlHeight: 40,
      controlHeightLG: 40,
    },
    Layout: {
      siderBg: '#3D3D50',
    },
    Menu: {
      itemHeight: 36,
      darkItemBg: '#3D3D50',
      darkSubMenuItemBg: '#3D3D50',
      darkItemSelectedBg: '#FFFFFF0F',
      darkItemColor: '#FFFFFFE0',
      darkItemSelectedColor: '#FFFFFFE0',
      subMenuItemSelectedColor: '#FFFFFFE0',
    },
    Pagination: {
      itemActiveBg: 'inherit',
      itemBg: 'inherit',
    },
    Select: {
      optionSelectedBg: '#E6F4FF',
      multipleItemBg: '#0000000A',
      fontSize: 14,
      fontSizeLG: 16,
      controlHeight: 40,
      controlHeightLG: 40,
    },
    Modal: {
      titleFontSize: 24,
      titleLineHeight: 1.5,
    },
    Tabs: {
      inkBarColor: '#3973AF',
      itemHoverColor: '#3973AF',
      itemSelectedColor: '#3973AF',
      horizontalItemPadding: '8px 0',
      lineHeight: 1.5,
      fontSize: 16,
      horizontalMargin: '0 0 18px 0',
    },
    Upload: {
      colorFillAlter: 'rgba(210, 234, 240, 0.5)',
      colorPrimary: '#3D3D50',
      controlItemBgHover: '#3D3D50',
      colorErrorBg: 'rgb(215, 227, 230)',
    },
    Progress: {
      defaultColor: 'rgb(22, 119, 255)',
    },
    Message: {
      fontSizeLG: 14,
    },
    Spin: {
      colorWhite: 'rgb(61, 61, 80)',
      dotSizeLG: 35,
      marginXXS: 2,
    },
    Table: {
      rowSelectedBg: 'rgba(0, 0, 0, 0)',
      rowSelectedHoverBg: 'rgba(0, 0, 0, 0)',
      cellFontSize: 14,
      lineHeight: 1.5,
      fontWeightStrong: 600,
      cellFontSizeMD: 14,
      cellFontSizeSM: 14,
      cellPaddingBlock: 16,
      cellPaddingInline: 16,
      cellPaddingBlockMD: 12,
      cellPaddingInlineMD: 8,
      cellPaddingBlockSM: 8,
      cellPaddingInlineSM: 8,
      footerBg: '#fff',
    },
    Radio: {
      dotSize: 8,
    },
    Switch: {
      innerMaxMargin: 29,
      innerMinMargin: 4,
    },
    TreeSelect: {
      nodeSelectedBg: '#3D3D50',
      nodeSelectedColor: '#FFFFFF',
      titleHeight: 22,
      controlHeight: 40,
      controlHeightLG: 40,
    },
  },
};
